module.exports = __webpack_public_path__ + "media/application/images/wjc-unesco-white@2x-2f9b3320ac900c17e27b0546539524da06546681226cbe4a695dfb5869e7dcf3.png";